import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { getModules } from '@modules';
import { mergeDeep } from './utils';

function loadDefaultLocaleMessages () {
    const locales = require.context(
        // Search for files in the current directory.
        '../app/locales',
        // Search for files in subdirectories.
        true,
        // Include any .json files
        /[A-Za-z0-9-_,\s]+\.json$/i
    );

    const messages = {}
    locales.keys().forEach(key => {
      const matched = key.match(/([A-Za-z0-9-_]+)\./i)
      if (matched && matched.length > 1) {
        const locale = matched[1]
        messages[locale] = locales(key);
      }
    })
    return JSON.parse(JSON.stringify(messages));
}

function loadPlatformLocaleMessages (config) {
    const locales = require.context(
        // Search for files in the current directory.
        `../configuration/platforms`,
        // Search for files in subdirectories.
        true,
        // Include any .json files
        /\/[A-Za-z0-9-_,\s]+\/locales\/[A-Za-z0-9-_,\s]+\.json$/i
    );

    const messages = {}
    locales.keys().forEach(key => {
      const matched = key.match(/([A-Za-z0-9-_]+)\/locales\/([A-Za-z0-9-_]+)\./i);
      if (matched && matched.length > 2) {
        const platform = matched[1];
        const locale = matched[2];
        if(platform == config.PLATFORM) {
            messages[locale] = locales(key);
        }
      }
    })
    return messages
}
export function createI18n (config) {

    const dateTimeFormats = {
        'en': {
            short: {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            }
        },
        'pt': {
            short: {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric'
            },
            datetime: {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
            }
        }
    }

    const numberFormats = {
        'en': {
            currency: {
                style: 'currency', currency: 'USD', notation: 'standard'
            },
            decimal: {
                style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
            },
            percent: {
                style: 'percent', useGrouping: false
            }
        },
        'pt': {
            currency: {
                style: 'currency', currency: 'EUR'
            }
        }
    }

    Vue.use(VueI18n);
    const i18n = new VueI18n({
        locale: 'pt', //navigator.language.split('-')[0] || process.env.APP_I18N_LOCALE || 'pt', // set locale
        fallbackLocale: 'pt', //process.env.APP_I18N_FALLBACK_LOCALE || 'pt',
        messages: loadDefaultLocaleMessages(), // set locale messages
        dateTimeFormats,
        numberFormats,
        silentTranslationWarn: true,
        silentFallbackWarn: true
    });

    return i18n;
};

const loadedModules = [];
export function setI18nLocales(i18n, module, store, config) {
    const {locales} = getModules(store, config);

    function setI18nModule (i18n, module) {
        i18n.module = module;
        return module
    }
    // If the same module
    if (i18n.module === module ||
        // If the module was already loaded
        loadedModules.includes(module)) {
        setI18nModule(i18n, module);
    }

    let defaultMessages = loadDefaultLocaleMessages();
    Object.entries(locales).forEach(([_module, _locales]) => {
        if(_module.toLowerCase() != module.toLowerCase()) return;

        let _messages = mergeDeep(defaultMessages, JSON.parse(JSON.stringify(_locales ?? {})));
        _messages = mergeDeep(_messages, JSON.parse(JSON.stringify(loadPlatformLocaleMessages(config) ?? {})));
        Object.entries(_messages).forEach(([_lang, _messages]) => {
            i18n.setLocaleMessage(_lang, _messages);
            // i18n.mergeLocaleMessage(_lang, _messages);
        });
    });

    loadedModules.push(module);
    setI18nModule(i18n, module);
}

const loadedLanguages = ['pt-PT']
export const languagesAvailable = ['pt-PT', 'en']

function setI18nLanguage (lang) {
  i18n.locale = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export function navigatorCloseLanguage () {
    const userLanguage = navigator.language
    if (languagesAvailable.includes(userLanguage)) {
        return loadLanguageAsync(userLanguage)
    } else if (userLanguage.includes('-')) {
        const userLanguageSplit = userLanguage.split('-')
        if (languagesAvailable.includes(userLanguageSplit[0])) {
            return loadLanguageAsync(userLanguageSplit[0])
        }
    }
    return 'pt-PT';
}

export function loadLanguageAsync (lang) {
    if (i18n.locale !== lang) {
        if (!loadedLanguages.includes(lang)) {
            // return import(/* webpackChunkName: "lang-[request]" */ `@/lang/${lang}`).then(msgs => {
            //     i18n.setLocaleMessage(lang, msgs.default)
            //     loadedLanguages.push(lang)
            //     return setI18nLanguage(lang)
            // })
        }
        return Promise.resolve(setI18nLanguage(lang));
    }
    return Promise.resolve(lang);
}